import { Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
    ProjectDetailDto,
    ProjectRelatedEntitiesContainerDto,
    ProjectService,
} from "../../../../api/psc";
import PrintProjectsView from "./PrintProjectsView";

// updated
export default function PrintProjectsContainer() {
    const query = new URLSearchParams(window.location.search);
    const [baseInfo, setBaseInfo] =
        useState<ProjectRelatedEntitiesContainerDto>();
    const [projectDetails, setProjectDetails] = useState<ProjectDetailDto[]>(
        []
    );
    const [projectsReady, setProjectsReady] = useState<boolean>(false);
    const [dataNotFound, setDataNotFound] = useState<boolean>(false);

    const printDataIdentifier = query.get("id");

    useEffect(() => {
        const printData = localStorage.getItem(printDataIdentifier);

        if (!printData) {
            setDataNotFound(true);
            return;
        }

        ProjectService.getProjectRelatedEntities("1").then((r) => {
            setBaseInfo(r);
            setProjectDetails(JSON.parse(printData));
            setProjectsReady(true);
            // localStorage.removeItem(printDataIdentifier);

            setTimeout(function () {
                const ua = navigator.userAgent.toLowerCase();
                const isAndroid = ua.indexOf("android") > -1;

                window.onafterprint = function () {
                    setTimeout(function () {
                        if (!isAndroid) {
                            window.close();
                        }
                    }, 5000);
                };

                window.print();

                // setTimeout(() => {
                //     if (!isAndroid) {
                //         window.close();
                //     }
                // }, 5000);
            }, 1000);
        });
    }, []);

    if (dataNotFound) {
        return (
            <Stack sx={{ m: 8 }} alignItems="center">
                <Typography>
                    داده یافت نشده لطفا مجددا از بخش پروژه ها اقدام به پرینت
                    نمایید!
                </Typography>
            </Stack>
        );
    }

    return (
        <PrintProjectsView
            baseInfo={baseInfo}
            projectDetails={projectDetails}
            projectsReady={projectsReady}
        />
    );
}
